/** @enum {string} */
export const GoalMetric = Object.freeze({
  APPLICATIONS_SENT: 'applications_sent',
  NETWORKING_OUTREACH: 'networking_outreach',
  CONVERSATIONS_COMPLETED: 'conversations_completed',
  INTERVIEWS_SCHEDULED: 'interviews_scheduled',
  CUSTOM: 'custom',
});

/** @enum {string} */
export const GoalPeriod = Object.freeze({
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  TOTAL: 'total',
});

export const GOAL_METRIC_LABELS = Object.freeze({
  [GoalMetric.APPLICATIONS_SENT]: 'Applications sent',
  [GoalMetric.NETWORKING_OUTREACH]: 'Outreach messages sent',
  [GoalMetric.CONVERSATIONS_COMPLETED]: 'Conversations completed',
  [GoalMetric.INTERVIEWS_SCHEDULED]: 'Interviews scheduled',
  [GoalMetric.CUSTOM]: 'Custom (manual)',
});
